/** @file downloadBrief: saves the art brief of the open puppet as art-brief.md. */
import type { EditorStore } from '../../state/editorTypes';
import type { BriefInput } from './artTypes';
import { briefTextOf } from './briefTextOf';
import { saveDownload } from './saveDownload';

/** Downloads `art-brief.md`; nothing happens when no puppet is open. */
export function downloadBrief(store: EditorStore, input: BriefInput): void {
  const puppet = store.getState().puppet.doc?.puppet;
  if (puppet === undefined) return;
  saveDownload('art-brief.md', { text: briefTextOf(puppet, input.views, input.style, input.includeFilled, input.mode).text, mime: 'text/markdown' });
}
